import { currencyFormat } from 'legacy/common/utils/currency';

const SummaryList = ({ data }) => (
  <ul className="flex justify-center border-t-1 mt-5 pt-4 flex-col">
    {data.map(({ title, subtitle, value }) => (
      <li key={title}>
        <div className="flex justify-between mb-4">
          <div>
            <div className="text-sm text-gray-500">{title}</div>
            <div className="mt-1 text-xs text-gray-400 font-light">
              {subtitle}
            </div>
          </div>
          <div className="text-base text-gray-500">{currencyFormat(value)}</div>
        </div>
      </li>
    ))}
  </ul>
);

export default SummaryList;
